import { am5, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

export const createAxes = ({
  root,
  data,
  chart,
  xAxisField,
  leftTitle,
  rightTitle,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.TableData;
  xAxisField: string;
  leftTitle: string;
  rightTitle: string;
}) => {
  const xRenderer = am5xy.AxisRendererX.new(root, {
    minGridDistance: 30,
    minorGridEnabled: true,
    rotation: 315,
  });

  // Create axes
  const categoryAxis = chart.xAxes.push(
    am5xy.CategoryAxis.new(root, {
      categoryField: xAxisField,
      renderer: xRenderer,
    })
  );

  categoryAxis.get('renderer').labels.template.setAll({
    fontSize: 11,
    textAlign: 'center',
    maxWidth: 150,
    rotation: 0,
    centerY: am5.p50,
  });

  categoryAxis.data.setAll(data);

  const valueAxis1 = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      autoZoom: false,
      renderer: am5xy.AxisRendererY.new(root, {}),
    })
  );

  valueAxis1.get('renderer').labels.template.setAll({
    fontSize: 11,
  });

  valueAxis1.children.unshift(
    am5.Label.new(root, {
      text: leftTitle,
      textAlign: 'center',
      rotation: -90,
      fontSize: 11,
      y: am5.p50,
    })
  );

  const valueAxis2 = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      autoZoom: false,
      renderer: am5xy.AxisRendererY.new(root, {
        opposite: true,
      }),
    })
  );

  valueAxis2.get('renderer').labels.template.setAll({
    fontSize: 11,
  });

  valueAxis2.children.push(
    am5.Label.new(root, {
      text: rightTitle,
      textAlign: 'center',
      rotation: 90,
      fontSize: 11,
      y: am5.p50,
    })
  );

  valueAxis2.get('renderer').grid.template.set('disabled', true);

  return { categoryAxis, valueAxis1, valueAxis2 };
};
